import {Color} from '@benchling/nucleus-ui';
import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {
  ANTIBODY_DOMAIN_CORNER_RADIUS,
  ANTIBODY_DOMAIN_HEIGHT,
  ANTIBODY_DOMAIN_WIDTH,
} from 'antibodies/AntibodyConstants';

const ANTIBODY_LABEL_FILL = Color.GRAY_100;
const ANTIBODY_LABEL_FILL_OPACITY = 0.3;

interface AntibodyDomainLabelProps {
  cornerRadius?: number;
  height?: number;
  text: string;
  width?: number;
}

/**
 * A short, mostly-transparent, rectangular label to overlay on an antibody domain.
 * This is an SVG component, so all units are 'abstract user units', relative to the SVG viewbox.
 * @param cornerRadius The radius of the corners
 * @param height The height of the label
 * @param text The text of the label
 * @param width The width of the label
 */
export default function AntibodyDomainLabel({
  cornerRadius = ANTIBODY_DOMAIN_CORNER_RADIUS / 2,
  height = ANTIBODY_DOMAIN_HEIGHT / 4,
  text,
  width = ANTIBODY_DOMAIN_WIDTH / 2,
}: AntibodyDomainLabelProps): JSX.Element {
  return (
    <>
      <g height={height} width={width}>
        <rect
          fill={ANTIBODY_LABEL_FILL}
          fillOpacity={ANTIBODY_LABEL_FILL_OPACITY}
          height={height}
          rx={cornerRadius}
          ry={cornerRadius}
          width={width}
        />
        <g transform={`translate(${width / 2}, ${height / 2})`}>
          <text
            className={css(styles.text)}
            dominantBaseline="central"
            fontSize={(5 * height) / 8}
            textAnchor="middle"
          >
            {text}
          </text>
        </g>
      </g>
    </>
  );
}

const styles = StyleSheet.create({
  text: {
    userSelect: 'none',
    cursor: 'pointer',
  },
});
